import { render, staticRenderFns } from "./KhVueAttachable.vue?vue&type=template&id=79aabe5e"
import script from "./KhVueAttachable.ts?vue&type=script&lang=ts&external"
export * from "./KhVueAttachable.ts?vue&type=script&lang=ts&external"
import style0 from "./KhVueAttachable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports